<template>
  <div class="grading-room-status-statistics">
    <div class="header-select-project">
      <SelectCdjProjectHeader  @onHeader="onHeader" ref="selectCdjProjectHeader" :items="['type_id','place_id','region_id','project_id']">
        <el-button type="primary" size="mini" @click="onPageChange(1)">查询</el-button>
<!--        <el-button type="primary" size="mini" @click="exportData()">导出房态统计</el-button>-->
        <div style="margin-top: 5px">
<!--          <el-checkbox-group size="mini" v-model="where.house_type" style="width: 100%;" @change="onPageChange(1)">-->
<!--            <el-checkbox label="1">住宅</el-checkbox>-->
<!--            <el-checkbox label="4">商铺</el-checkbox>-->
<!--            <el-checkbox label="5">写字楼</el-checkbox>-->
<!--            <el-checkbox label="2">车位</el-checkbox>-->
<!--            <el-checkbox label="3">储藏室</el-checkbox>-->
<!--          </el-checkbox-group>-->
        </div>
      </SelectCdjProjectHeader>
    </div>
    <div class="table-container">
      <el-table v-loading="loading" :data="pageData.data" border style="width: 100%" height="70vh">
        <el-table-column label="项目" prop="project_name" width="200" fixed></el-table-column>
        <el-table-column label="房产数量" prop="total_number" align="center" width="100"></el-table-column>
        <el-table-column label="空置户数" prop="vacant_number" align="center" width="100"></el-table-column>
        <el-table-column label="年月" prop="month" align="center" width="100" min-width="200"></el-table-column>
        <el-table-column label="费项" prop="charge_item_name" align="center"></el-table-column>
        <el-table-column label="空置率" prop="rate" align="center" width="100"></el-table-column>
        <el-table-column label="未计费户数" prop="not_generate_count" align="center" width="100"></el-table-column>
        <el-table-column label="已计费户数" prop="generate_count" align="center" width="100"></el-table-column>
        <el-table-column label="折扣金额(元)" prop="discount_amount" align="center" width="100"></el-table-column>

      </el-table>
    </div>
    <div class="footer-pagination">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        :total="pageData.total" :page-size="pageData.per_page" :current-page="pageData.current_page"
        @current-change="onPageChange"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import SelectCdjProjectHeader from "../../Butler/components/common/SelectCdjProjectHeader";
export default {
  name: "CenterDiscountMonthlyList",
  components: {SelectCdjProjectHeader},
  data() {
    return{
      where:{
        project_id:null,
        project_ids:'',
        level:'',
        house_type:['1','4','5']
      },
      pageData:{
        page: 1,
        per_page: 10,
        data:[],
        total:0
      },
      loading:false,
    }
  },
  mounted() {
    const that=this;
    that.$nextTick(() => {
      that.$refs.selectCdjProjectHeader.getAllTree(()=>{
        that.$refs.selectCdjProjectHeader.initLegalSearchObj()
        that.onPageChange()
      });
    });
  },
  methods: {
    onHeader(header) {
      console.log(header);
      this.where.project_ids=header.project_ids;
      this.where.project_id=header.project_name;
      this.where.level=header.level;
      this.onPageChange();
    },
    onPageChange(page=1){
      this.pageData.page=page;
      this.getList();
    },
    getList(){
      const that=this;
      that.loading=true;
      ERP.postRequest({
        url:"admin/CenterDiscountMonthly/getList2?page="+that.pageData.page+"&per_page="+that.pageData.per_page,
        data:{
          project_ids:that.where.project_ids,
          project_id:that.where.project_id,
          level:that.where.level,
          house_type:that.where.house_type.join(',')
        },
      },ret=>{
        that.loading=false;
        if(ret.code){
          that.pageData=ret.data;
        }
      })
    },
    exportData(){
      const that=this;
      that.loading=true;
      ERP.postRequest({
        url:"admin/CustomerHouse/getGradingRoomStatusExcel",
        data:{
          project_ids:that.where.project_ids,
          project_id:that.where.project_id,
          level:that.where.level,
          house_type:that.where.house_type.join(',')
        },
      },ret=>{
        that.loading=false;
        if(ret.code){
          window.open(ret.data)
        }
      })
    },
    formatFloat(num) {
      return this.round(num*100, 2);
    },
    round(num, n=2) {
      return Math.round(num * Math.pow(10, n)) / Math.pow(10, n);
    }
  }
}
</script>

<style lang="scss" scoped>
.el-button--primary,.el-button--success,.el-button--danger,.el-button--warning {
  color: #FFF;
}
.grading-room-status-statistics{
  .header-select-project{
    margin-bottom: 10px;
  }
  .table-container{
    margin-bottom: 10px;
    .count{
      font-size: 14px;
      font-weight: bold;
    }
    .percent{
      font-size: 12px;
      color: #999;
    }
  }
  .footer-pagination{
    margin-top: 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/HouseCode/components/CenterDiscountMonthlyList.vue